function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
var dataSculptor = function dataSculptor(state) {
  var tokens = [];
  var _iterator = _createForOfIteratorHelper(state.tokens),
    _step;
  try {
    var _loop = function _loop() {
      var _token$children;
      var token = _step.value;
      var tokenChildren = [];
      if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
        tokens.push(token);
        return 1; // continue
      }
      if (token.children) {
        token.children.forEach(function (childToken) {
          if (childToken.type === 'text' && SCULPTOR_REGEX.test(childToken.content)) {
            var citationToken = new state.Token('status', '', 0);
            citationToken.content = '';
            citationToken.block = false;
            citationToken.level = childToken.level;
            citationToken.attrs = [['localId', 'data-sculptor'], ['text', 'data-sculptor'], ['color', 'blue']];
            var parts = childToken.content.split(SCULPTOR_REGEX);
            parts.forEach(function (part, index) {
              if (index % 2 === 0) {
                var textToken = new state.Token('text', '', 0);
                textToken.content = part;
                textToken.level = childToken.level;
                tokenChildren.push(textToken);
              } else {
                tokenChildren.push(citationToken);
              }
            });
            return;
          }
          tokenChildren.push(childToken);
        });
      }
      var filteredTokenChildren = tokenChildren.filter(function (childToken) {
        return childToken !== null;
      });
      token.children = filteredTokenChildren;
      tokens.push(token);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  state.tokens = tokens;
  return;
};
export default (function (md) {
  return md.core.ruler.push('data-sculptor', dataSculptor);
});